<template>
    <div>
        <table class="table mt-4  rounded-lg shadow">
          <thead>
            <tr>
              <th class="border border-gray-900 text-lg whitespace-nowrap font-bold text-gray-900">
                Subject
              </th>
              <th class="border border-gray-900 p-2 whitespace-nowrap font-bold text-lg text-gray-900">
                Test 1 (A)
              </th>
              <th class="border border-gray-900 p-2  whitespace-nowrap font-bold text-lg text-gray-900">
                Test 2 (B)
              </th>
              <th class="border border-gray-900 p-2  whitespace-nowrap font-bold text-lg text-gray-900">
                Test 3 (C)
              </th>

              <th class="border border-gray-900 p-1  font-bold text-lg text-gray-900 ">
                (D) Test Ave (A+B+C)/3
              </th>
              <th class="border border-gray-900 p-2  whitespace-nowrap font-bold text-lg text-gray-900">
                Exam (E)
              </th>
              <th class="border border-gray-900 p-1 font-bold text-lg text-gray-900">
                (F) Term Cum (D+E)/2
              </th>
              <th class="border border-gray-900 p-2  whitespace-nowrap font-bold text-lg text-gray-900">
                Last Cum (G)
              </th>
              <th class="border border-gray-900 p-1   font-bold text-lg text-gray-900">
                (H) Term Cum (F+G)/2
              </th>
              <th class="border border-gray-900 p-2  whitespace-nowrap font-bold text-lg text-gray-900">
                Grade
              </th>
              <th class="border border-gray-900 p-2  whitespace-nowrap font-bold text-lg text-gray-900">
                Remarks
              </th>

            </tr>
          </thead>
          <tbody>
            <tr v-for="(subject, index) in studentSubjects" :key="index">
              <td  class="border border-gray-900  px-2 font-bold text-gray-900">
                {{subject.subject.name}}
              </td>
              <td :class="{ 'border border-gray-900 p-2 text-center font-bold': true,  }">
                {{ subject.testOne }}
              </td>
              <td :class="{ 'border border-gray-900 p-2 text-center font-bold': true,  }">
                {{  subject.testTwo }}
              </td>
              <td :class="{ 'border border-gray-900 p-2 text-center font-bold': true,  }">
                {{ subject.testThree }}
              </td>
              <td :class="{ 'border border-gray-900 p-2 text-center font-bold': true, }">
                {{ Math.floor((subject.testOne + subject.testTwo + subject.testThree) / 3) }}
              </td>
              <td class="border border-gray-900 p-2 text-center font-bold text-gray-900">
               {{subject.exam}}
              </td>
              <td :class="{ 'border border-gray-900 p-2 text-center font-bold': true,  }">
                {{ Math.floor((subject.testOne + subject.testTwo + subject.testThree + subject.exam) / 4) }}
              </td>
              <td :class="{ 'border border-gray-900 p-2 text-center font-bold': true,  }">
                {{ subject.lastTermCumulative }}
              </td>
              <td :class="{ 'border border-gray-900 p-2 text-center font-bold': true,  }">
                {{ subject.cumulative }}
              </td>
              <td :class="{ 'border border-gray-900 p-2 text-center font-bold': true,   }">

              </td>
              <td class="border border-gray-900 p-2 text-center font-bold text-gray-900">

              </td>

            </tr>

          </tbody>

        </table>

    </div>
</template>

<script setup lang="ts">
import { LocalStorageKeys } from '@/constants/LocalStorageKey.constant';
const studentSubjects = ref(JSON.parse(localStorage.getItem(LocalStorageKeys.subjectsData)));
</script>

<style lang="scss" scoped>

</style>
